<template>
  <div class="tags">
    <header>
      <p v-on:click="backHistory" style="padding-left: 0; " @click="">
        <img src="@/assets/img/back.png" alt="">
        <span style="color: #FFFFFF">职位关键词</span>
      </p>
      <p style="padding-right: 1rem;color: #FFFFFF " @click="save">保存</p>
    </header>
    <p>选择你的职位关键词  <span class="tagLen">{{keywordList.length}}/6</span></p>
    <div>
      <span class="keyword" v-for="(item,index) in keywordList" :key="index">{{item.name}} <span @click="deleteTag(index)">×</span></span>
    </div>
    <p>选择职业的行业关键词</p>
    <ul>
      <li :class="{active:keywordList.indexOf(item)>-1}" v-for="(item,index) in tradeList" :key="index" @click="appendTag(item)">{{item.name}}</li>
    </ul>
    <p>选择职位所需的技能</p>
    <ul>
      <li :class="{active:keywordList.indexOf(item)>-1}" v-for="(item,index) in professionList" :key="index" @click="appendTag(item)">{{item.name}}</li>
    </ul>

  </div>
</template>

<script>
  export default {
    name: 'message',
    data() {
      return {
        msg: '',
        color: "#FFFFFF",
//        color:"#000000",
        bool: true,
        tradeList: [],
        professionList: [],
        keywordList:[]
      }
    },
    methods: {
      backHistory(){
        this.$router.push("/releasePosition")
      },
      clickIcon(event) {
        console.log(event)
        this.bool = !this.bool
        console.log(this.bool)
//        if(bool){
//          this.color="FFFFFF"
//        }
//        this.color="#FFFFFF"
      },
      getArr(){
        if(localStorage.getItem('keyWord')){
          this.keywordList=JSON.parse(localStorage.getItem('keyWord'))

        }
      },
      getWorkTags() {
        this.$api.getWord().then(res => {
          if (res.status == 200) {
            this.tradeList = res.data.hangye
            this.professionList = res.data.zhiye
          }
        })
      },
      appendTag(item){
        if(this.keywordList.length>5) return;
        console.log(this.keywordList.indexOf(item))
//        if(this.keywordList.indexOf(item)>-1) return;
        if(JSON.stringify(this.keywordList).indexOf(JSON.stringify(item))>-1) return;
        this.keywordList.push(item);
      },
      deleteTag(index){
        this.keywordList.splice(index,1)
      },
      save(){
        localStorage.setItem("keyWord",JSON.stringify(this.keywordList))
        this.$router.push("/releasePosition")
      }
    },
    mounted() {
      this.getWorkTags()
      this.getArr()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
  /*@import '../assets/css/common.css';*/
  /*@import '../assets/css/header.css';*/
  /*@import '../assets/css/footer.css';*/
  /*@import '../assets/css/mui.min.css';*/
  /*<link rel="stylesheet" href="css/mui.min.css">*/
  header{
    width: 100%;
    height: 65px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /*padding: 0 1rem;*/
  }
  header p{
    display: flex;
  }
  header img{
    width: 20px;
    height: 20px;
  }

  .communicate {
    width: 50px;
    height: 50px;
    /*border-radius:100% ;*/
  }

  .communicate img {
    width: 100%;
    /*width: 100%;*/
    border-radius: 100%;
  }

  .communicateRight {
    display: flex;
    /*display: flex;*/
    justify-content: space-between;
    padding-top: 6px;
    font-size: 1px;
  }

  .tagLen {
    color: lightgrey;
    padding-left: 10px;
  }

  .tags {
    /*padding: 20px;*/
    padding-top: 65px;

  }

  .tags p {
    font-size: 16px;
    /*margin-bottom: 0;*/
  }

  ul {
    display: flex;
    flex-wrap: wrap
  }

  ul li {
    border: solid 1px #e2e2e2;
    padding: 3px 5px;
    margin-right: 10px;
    margin-top: 10px;
    border-radius: 4px;
    font-size: 13px;
  }
  .keyword{
    background: #00A1FF;
    color: #FFFFFF;
    padding: 3px 5px;
    margin-right: 10px;
    border-radius: 4px;
    white-space: nowrap;
    font-size: 13px;
    display: inline-block;
    margin-top: 10px;
  }
  li.active{
    background: #00A1FF;
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/addkeyWord.vue